<!-- 配件销售历史 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">创建时间</div>
                <div class="search-item">
                    <el-date-picker v-model="dateTimes" type="daterange" size="small" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" :picker-options="pickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                        @change="handleChange"></el-date-picker>
                </div>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch" style="height: 32px">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch" style="height: 32px">重置</el-button>
                <el-button size="small" class="search-btn" type="primary" @click="showSetDialog()">创建任务</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%; margin-bottom: 0px">
                <el-table-column min-width="140px" prop="TaskName" label="任务名称" show-overflow-tooltip></el-table-column>
                <el-table-column show-overflow-tooltip min-width="190px" prop="NeedExecTime" label="期望执行时间"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="StateName" label="执行状态"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="160px" prop="ExeStartTime" label="任务执行时间"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="ExeCount" label="结果总数"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="TaskDesc" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="160px" prop="CreateTime" label="创建时间"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button type="text" size="mini" v-if="scope.row.StateName != '已执行' && scope.row.StateName != '正在执行'"
                                @click="showSetDialog(scope.row)">修改</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchData.page" :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit" layout="total, sizes, prev, pager, next, jumper" :total="tableDataLength"></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="isShowSet" width="450px" append-to-body :modal="false">
            <div class="dialog-content" v-if="isShowSet">
                <el-form ref="form" label-position="left" label-width="100px">
                    <el-form-item label="任务类型"  prop='TaskType'>
                        <el-select size="small" class="search-item" style="width: 100%" v-model="taskData.TaskType" placeholder="任务类型">
                            <el-option key="5" label="自动采购" value="5"></el-option>
                            <el-option key="6" label="新品调拨" value="6"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="期望执行时间"  prop='ExeTime'>
                        <el-date-picker style="width: 100%" size="small" v-model="taskData.ExeTime" type="datetime" placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注" prop='TaskDesc'>
                        <el-input style="width: 100%" size="small" v-model="taskData.TaskDesc"></el-input>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer" style="text-align: right">
                    <el-button size="small" @click="closeSetDialog">取消</el-button>
                    <el-button class="btn-primary" size="small" @click="confirmData">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: '',
    props: {},
    components: {},
    data() {
        return {
            loading: false,
            dialogTitle: '',
            searchData: {
                page: 1,
                limit: 10,
                StartDate: '',
                EndDate: ''
            },
            taskData: {
                Id: '',
                TaskType: "5",
                TaskDesc: '',
                ExeTime: ''
            },
            dateTimes: [],
            tableData: [],
            tableDataLength: 0,
            isShowSet: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        handleChange(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        // 搜索顾客
        resetSearch() {
            this.searchData = {
                page: 1,
                limit: 10,
                TaskType: '5',
                StartDate: '',
                EndDate: ''
            };
            this.dateTimes = [];
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetAutoPurTaskList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        confirmData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosPost({
                    url: '/api/EntpPurchaseOrder/SaveAutoPurTask',
                    data: that.taskData,
                    hideLoading: true,
                })
                .then((resp) => {
                    if (resp.errcode == 0) {
                        that.$util.successMsg('保存成功');
                        that.getTableData();
                        that.closeSetDialog();
                    }
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        showSetDialog(item) {
            this.isShowSet = true;
            if (item) {
                this.dialogTitle = "编辑任务";
                this.taskData.Id = item.Id;
                this.taskData.TaskDesc = item.TaskDesc;
                this.taskData.TaskType = item.TaskType+"";
                if (this.taskData.ExeTime && this.taskData.ExeTimethis.taskData.ExeTime != '-')
                    this.taskData.TaskDesc = item.TaskDesc;
            }
            else
                this.dialogTitle = "创建任务";
        },
        closeSetDialog() {
            this.isShowSet = false;
            this.taskData = {
                Id: '',
                TaskDesc: '',
                ExeTime: '',
            };
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn {
    .search-ctn-left {
        margin-top: 5px;

        .search-name,
        .search-item,
        button {
            margin-bottom: 10px;
        }
    }

    .search-btn,
    .search-item {
        margin-bottom: 0;
    }
}

.el-form-item {
    margin-bottom: 0;
}
</style>
